import axios from "axios";
import { app } from '@/main.js'
import store from "@/store";

export default {
    async refreshToken () {
      if (store.state.auth.jwtPayload == null){
        return;
      }

      let data = {
        id: store.state.auth.jwtPayload.user_id,
        access_token: store.state.auth.accessToken,
        refresh_token: store.state.auth.jwtPayload.jwt_refresh_token
      }

      let res = await axios.post('/users/token/refresh', data)
      .then(response => {
        if (response.data.success){
          store.commit("auth/setAccessToken", response.data.user.access_token);
          store.commit("auth/setJwtPayload", app.helpers.parseJwt(response.data.user.access_token));
          return response.data.user.access_token;
        } else {
          store.commit('auth/setTokenExpires');
          store.dispatch('auth/logout');
        }
      })
      .catch(store.commit('auth/setTokenExpires'))

      return res;
    },
  }